// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep app-upload-certificate {
   display: block;
   width: 312px;
}

.error {
   font-size: 12px;
   margin-top: 5px;
}

.pwd-hint {
   margin-bottom: 1em;
}

input {
   height: 32px;
   padding-right: 36px;
   width: 100%;
}

mat-icon {
   width: 32px;
   height: 32px;
   line-height: 32px;
   padding: 4px;
   text-align: center;
   right: 0;
}

.upload-cert {
   border: 2px dashed #ccc;
   border-radius: 4px;
   background-color: #f9f9f9;
   padding: 20px;
   position: relative;
   text-align: center;
}

.upload-cert:hover {
   background-color: #f4f5f7;
}

div.image-cert {
   content: url('certificate.svg');
   margin: 0 auto 20px;
   width: 20%;
}

.file-input {
   cursor: pointer;
   opacity: 0.0;
   position: absolute;
   top: 0;
   left: 0;
   bottom: 0;
   right: 0;
   width: 100%;
   height: 100%;
}

.upload-cert img {
   max-width: 100%;
   max-height: 100%;
}

.word-cert {
   font-size: 20px;
   margin-bottom: 4px;
}

.word-size-cert {
   color: #ffa726;
   margin-top: 8px;
}

.info-size{
   font-size:12px;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/account/upload-certificate/upload-certificate.component.css"],"names":[],"mappings":"AAAA;GACG,cAAc;GACd,YAAY;AACf;;AAEA;GACG,eAAe;GACf,eAAe;AAClB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,YAAY;GACZ,mBAAmB;GACnB,WAAW;AACd;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,iBAAiB;GACjB,YAAY;GACZ,kBAAkB;GAClB,QAAQ;AACX;;AAEA;GACG,uBAAuB;GACvB,kBAAkB;GAClB,yBAAyB;GACzB,aAAa;GACb,kBAAkB;GAClB,kBAAkB;AACrB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,+BAA4C;GAC5C,mBAAmB;GACnB,UAAU;AACb;;AAEA;GACG,eAAe;GACf,YAAY;GACZ,kBAAkB;GAClB,MAAM;GACN,OAAO;GACP,SAAS;GACT,QAAQ;GACR,WAAW;GACX,YAAY;AACf;;AAEA;GACG,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,wBAAwB;AAC3B","sourcesContent":["::ng-deep app-upload-certificate {\n   display: block;\n   width: 312px;\n}\n\n.error {\n   font-size: 12px;\n   margin-top: 5px;\n}\n\n.pwd-hint {\n   margin-bottom: 1em;\n}\n\ninput {\n   height: 32px;\n   padding-right: 36px;\n   width: 100%;\n}\n\nmat-icon {\n   width: 32px;\n   height: 32px;\n   line-height: 32px;\n   padding: 4px;\n   text-align: center;\n   right: 0;\n}\n\n.upload-cert {\n   border: 2px dashed #ccc;\n   border-radius: 4px;\n   background-color: #f9f9f9;\n   padding: 20px;\n   position: relative;\n   text-align: center;\n}\n\n.upload-cert:hover {\n   background-color: #f4f5f7;\n}\n\ndiv.image-cert {\n   content: url('assets/icons/certificate.svg');\n   margin: 0 auto 20px;\n   width: 20%;\n}\n\n.file-input {\n   cursor: pointer;\n   opacity: 0.0;\n   position: absolute;\n   top: 0;\n   left: 0;\n   bottom: 0;\n   right: 0;\n   width: 100%;\n   height: 100%;\n}\n\n.upload-cert img {\n   max-width: 100%;\n   max-height: 100%;\n}\n\n.word-cert {\n   font-size: 20px;\n   margin-bottom: 4px;\n}\n\n.word-size-cert {\n   color: #ffa726;\n   margin-top: 8px;\n}\n\n.info-size{\n   font-size:12px;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
